@for (row of rows; track row; let i = $index) {
  <div class="spa-list-row-container" data-testid="guest_including_companions">
    <div
      class="spa-list-row outer"
      data-testid="main_guest"
      [class.border]="showBorder()"
      [class.spa-list-age-issue]="rowContainsError(row[rowId])"
    >
      <div
        class="spa-list-row"
        (click)="onClickRow(row)"
        [ngClass]="{
          'spa-list-selected-row': row[rowId] === selectedRow,
          'spa-list-hint': rowContainsHint(row[rowId]),
          'spa-list-interactive': interactive,
        }"
        id="list-row-{{ i }}"
        data-testid="selected_person"
      >
        <spa-button
          (clickedButton)="removeSelectedEmployee(i)"
          id="list-row-delete-btn-{{ i }}"
          shape="link"
          asset="close"
          data-testid="remove_selected_person_button"
        ></spa-button>
        @for (column of positionedList.left; track column; let j = $index) {
          <div class="spa-list-element-container" [ngClass]="[column.size ?? '']" [attr.data-testid]="column.key">
            @if (getTemplate(column.key); as tmp) {
              <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
            } @else {
              <dx-text-input
                label="{{ (translationKey(column) | transloco) || null }}"
                value="{{ cellValue(row, column) }}"
                readonly="true"
                [ngClass]="[column.size ?? '']"
                id="{{ column.key }}-{{ i }}"
                [attr.data-testid]="column.key"
              ></dx-text-input>
            }
          </div>
        }
      </div>

      @for (column of positionedList.right; track column; let j = $index) {
        <div class="spa-list-element-container" id="{{ column.key }}-{{ i }}" [ngClass]="[column.size ?? '']">
          @if (getTemplate(column.key); as tmp) {
            <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
            <div class="spa-list-newprice-tag" id="newprice-{{ i }}"></div>
          } @else {
            <dx-text-input
              label="{{ (translationKey(column) | transloco) || null }}"
              value="{{ cellValue(row, column) }}"
              readonly="true"
              [ngClass]="[column.size ?? '']"
              id="{{ column.key }}-{{ i }}"
            ></dx-text-input>
          }
        </div>
      }
    </div>

    <!-- Age Restriction -->
    <dx-error-message>{{ rowContainsError(row[rowId]) ? errorText() : "" }}</dx-error-message>

    <!-- Overlapping Bookings -->
    <div
      class="spa-list-bottom-space-and-hint-text"
      [title]="rowContainsHint(row[rowId]) ? hintText : ''"
      data-testid="overlapping_booking_hint"
    >
      {{ rowContainsHint(row[rowId]) ? hintText : "" }}
    </div>

    @for (column of positionedList.bottom; track column.key) {
      <div class="spa-list-bottom-container" id="{{ column.key }}-{{ i }}" [ngClass]="[column.size ?? '']">
        @if (getTemplate(column.key); as tmp) {
          <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
          <div class="spa-list-newprice-tag" id="newprice-{{ i }}"></div>
        } @else {
          <dx-text-input
            label="{{ (translationKey(column) | transloco) || null }}"
            value="{{ cellValue(row, column) }}"
            readonly="true"
            [ngClass]="[column.size ?? '']"
            id="{{ column.key }}-{{ i }}"
          ></dx-text-input>
        }
      </div>
    }
  </div>
}
